import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'app-timer',
    template: '<span>{{ timer }}</span>',
    standalone: false
})
export class TimerComponent implements OnInit, OnDestroy {
  timer = 0;
  private intervalId: any;

  ngOnInit() {
    this.intervalId = setInterval(() => {
      this.timer++;
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }
}
